import { render, staticRenderFns } from "./maintenance.vue?vue&type=template&id=090c979e&scoped=true&"
import script from "./maintenance.vue?vue&type=script&lang=js&"
export * from "./maintenance.vue?vue&type=script&lang=js&"
import style0 from "./maintenance.vue?vue&type=style&index=0&id=090c979e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090c979e",
  null
  
)

export default component.exports